module.exports = __webpack_public_path__ + "img/DM.540e0e74.png";